import React from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, useSlug } from '@bloomberg/media-ui-core';

import { DropdownListItem, SubmenuItem, THEMES } from '../types';

import styles from './DropdownMenuMobile.module.css';

export type DropdownMenuMobileProps = GlobalProps & {
  menuItemId: string;
  submenuItems?: Record<string, SubmenuItem>;
  items?: DropdownListItem[];
  theme?: THEMES;
  trackingFunction: (submenuText: string, dropdownListItemText: string) => void;
};

export const DropdownMenuMobile = React.forwardRef<
  HTMLDivElement,
  DropdownMenuMobileProps
>(function DropdownMenuMobileComponent(props: DropdownMenuMobileProps, ref) {
  const {
    items,
    menuItemId,
    submenuItems,
    theme = THEMES.LIGHT,
    trackingFunction,
  } = props;

  const componentName = useSlug('dropdown-menu-mobile');

  if (
    !(submenuItems && Object.keys(submenuItems).length) &&
    !(items && Object.keys(items).length)
  ) {
    return null;
  }

  const cx = classes([
    styles.dropdownMenuMobileContainer,
    {
      [styles.light]: theme === THEMES.LIGHT,
      [styles.dark]: theme === THEMES.DARK,
      [styles.blue]: theme === THEMES.BLUE,
    },
  ]);

  return (
    <div
      className={cx}
      ref={ref}
      id="dropdown-menu-mobile"
      data-testid="dropdown-menu-mobile"
      aria-label="Menu"
      data-component={componentName}
      data-menuid={menuItemId}
    >
      {submenuItems &&
        Object.entries(submenuItems).map(
          ([submenuId, { id, text, dropdownListItems }]) => {
            if (!text || !dropdownListItems?.length) {
              return null;
            }

            return (
              <div className={styles.submenu} key={id}>
                <div
                  className={styles.submenuText}
                  data-menuid={menuItemId}
                  data-submenuid={submenuId}
                >
                  {text}
                </div>
                {dropdownListItems.map((item) => (
                  <a
                    className={styles.link}
                    data-menuid={menuItemId}
                    data-submenuid={menuItemId}
                    href={item.url}
                    onClick={() => trackingFunction(text, item.text)}
                    key={item.id}
                  >
                    {item.text}
                  </a>
                ))}
              </div>
            );
          }
        )}
    </div>
  );
});
